// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 60 60" {...rest} unit={unit}>
		<title>Emergency</title>
		<g>
			<circle id="Oval" fill="#CF3B8E" cx="30" cy="30" r="30"></circle>
			<polygon id="Path" fill="#FFFFFF" points="15 34.5 15 25.5 45 25.5 45 34.5"></polygon>
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Emergency.js